import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button, Typography } from 'antd';
import { 
  QrcodeOutlined, 
  LeftOutlined, 
  RightOutlined,
  BulbOutlined,
  MoonOutlined,
  //user
  HomeTwoTone,
  MobileTwoTone, 
  ControlTwoTone,
  BookTwoTone,
  ProfileTwoTone,
  SecurityScanTwoTone,
  AppstoreTwoTone,
  ContactsTwoTone,
  //admin
  SettingOutlined,
  BookOutlined,
  MobileOutlined,
  ControlOutlined,
  SecurityScanOutlined,
  CodeOutlined,
  CalendarOutlined,
  SkinTwoTone
} from '@ant-design/icons'; 
import { Link, useLocation } from 'react-router-dom'; 
import axios from '../../config/axiosInstance';
import { useAuth } from '../../context/AuthContext';
 
const { Sider } = Layout;

const Sidebar = ({ collapsed, toggleCollapse, toggleTheme, darkTheme }) => {
  const location = useLocation();
  const [showButton, setShowButton] = useState(false);
  const [brand, setBrand] = useState({
    portalLogo: null,
    portalName: null,
  });

  const { user, hasFeature } = useAuth();

  useEffect(() => {
    // Request to obtain the configuration of the mark
    const fetchBrand = async () => {
      try {
        const response = await axios.get('/clients/brand');
        
        if (response.status === 200) {
          setBrand(response.data); 
        } else {
          console.error('Error fetching brand clients:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching brand clients:', error.message);
      }
    };

    fetchBrand();
  }, []);

  // Set defaults if they do not exist
  const portalName = brand.portalName || 'Regasus';
  const portalLogo = brand.portalLogo;

  // Define the main menu items
  const menuItems = [
    {
      key: '/home',
      icon: <HomeTwoTone style={{ fontSize: '20px' }} />,
      label: <Link to="/home" style={{ fontSize: '16px' }}>Home</Link>,
    },
    {
      key: '/devices',
      icon: <MobileTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/devices" style={{ fontSize: '16px' }}>Devices</Link>,
    },
    {
      key: '/deviceconfigs',
      icon: <ControlTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/deviceconfigs" style={{ fontSize: '16px' }}>Device Config</Link>,
    },
    {
      key: '/events',
      icon: <BookTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/events" style={{ fontSize: '16px' }}>Events</Link>,
    },
    {
      key: '/participants',
      icon: <ContactsTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/participants" style={{ fontSize: '16px' }}>Participants</Link>,
      feature: 'participants.view',
    },
    {
      key: '/lead-policy',
      icon: <SecurityScanTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/lead-policy" style={{ fontSize: '16px' }}>Lead Policy Editor</Link>,
      feature: 'leadpolicy.view',
    },
    {
      key: '/lead-control',
      icon: <ProfileTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/lead-control" style={{ fontSize: '16px' }}>Lead Control</Link>,
      feature: 'lead-control.view',
    },
    {
      key: '/apps',
      icon: <AppstoreTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/apps" style={{ fontSize: '16px' }}>Apps</Link>,
    },
    {
      key: '/design',
      icon: <SkinTwoTone style={{ fontSize: '18px' }} />,
      label: <Link to="/design" style={{ fontSize: '16px' }}>Design</Link>,
      feature: 'deviceConfig.design',
    },
  ];

  // Items for Admins
  const adminItems = [
    {
      key: '/admin-panel',
      icon: <SettingOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-panel" style={{ fontSize: '16px' }}>Admin Panel</Link>,
    },
    {
      key: '/admin-events',
      icon: <BookOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-events" style={{ fontSize: '16px' }}>Events</Link>,
    },
    {
      key: '/admin-devices',
      icon: <MobileOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-devices" style={{ fontSize: '16px' }}>Devices</Link>,
    },
    {
      key: '/admin-deviceconfigs',
      icon: <ControlOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-deviceconfigs" style={{ fontSize: '16px' }}>Device Config</Link>,
    },
    {
      key: '/admin-lead-policy',
      icon: <SecurityScanOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-lead-policy" style={{ fontSize: '16px' }}>Lead Policy Editor</Link>,
    },
    {
      key: '/admin-console-logs',
      icon: <CodeOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-console-logs" style={{ fontSize: '16px' }}>Console.Logs</Link>,
    },
    {
      key: '/admin-planner',
      icon: <CalendarOutlined style={{ fontSize: '18px', color:'#F2A11F' }} />,
      label: <Link to="/admin-planner" style={{ fontSize: '16px' }}>Planner</Link>,
    },
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={toggleCollapse}
      trigger={null}
      width={256}
      collapsedWidth={80}
      style={{
        backgroundColor: darkTheme ? '#141414' : '#ffffff',
        borderRight: darkTheme ? '1px solid #555' : '1px solid #e0e0e0',
        position: 'relative',
        zIndex: 2,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        transition: 'background-color 0.8s ease, color 0.8s ease, border-color 0.8s ease',
      }}
      onMouseEnter={() => setShowButton(true)}
      onMouseLeave={() => setShowButton(false)}
    >
      {showButton && (
        <Button
          type="link"
          icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
          onClick={toggleCollapse}
          style={{
            position: 'fixed',
            top: 20,
            left: collapsed ? 80 : 256,
            transform: 'translateX(-50%)',
            borderRadius: '50%',
            backgroundColor: darkTheme ? '#141414' : '#ffffff',
            border: '1px solid #e0e0e0',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 3,
            transition: 'opacity 0.3s',
          }}
        />
      )}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        padding: '20px',
        paddingLeft: '26px',
        backgroundColor: darkTheme ? '#141414' : '#ffffff', 
        fontSize: '24px', 
        fontWeight: 'bold',
        color: darkTheme ? '#ffffff' : '#000000',
        transition: 'background-color 0.8s ease, color 0.8s ease',
      }}>
      {portalLogo ? (
        <img src={portalLogo} alt="Logo" 
          style={{ 
            maxWidth: '32px',
            maxHeight: '32px',
            marginRight: '10px' 
          }} />
      ) : (
        <QrcodeOutlined style={{ fontSize: '32px', marginRight: '10px', color: '#1890ff' }} />
      )}
      {!collapsed && portalName}
      </div>
      <div
          style={{
            flex: 1,
            overflowY: 'auto',
            paddingBottom: '80px',
          }}
      >
        <Menu
            theme={darkTheme ? "dark" : "light"}
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{
              borderInlineEnd: 'none',
              marginTop: '16px',
              flex: 1,
            }}
        >
          {menuItems.map((item) =>
              // We filter the items according to whether the user has the feature
              !item.feature || hasFeature(item.feature) ? (
                  <Menu.Item key={item.key} icon={item.icon}>
                    {item.label}
                  </Menu.Item>
              ) : null
          )}
        </Menu>
        {/* -- Group = "admin" -- */}
        {user?.groupID?.name === 'admin' && (
          <>
          {/* Separator between menus */}
          <div style={{
            height: '1px',
            backgroundColor: darkTheme ? '#e0e0e0' : '#e0e0e0',
            margin: '16px 0',
            borderTop: darkTheme ? '1px solid rgb(85, 85, 85)' : '1px solid rgb(224, 224, 224)',
          }} />
          <div
          style={{
            display: collapsed ? 'none' : 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '5px',
          }}
          >
            <Typography.Title
              level={4}
              style={{ margin: 0, color:'#F2A11F' }}
            >
              Administration
            </Typography.Title>
          </div>

          <Menu
            theme={darkTheme ? "dark" : "light"}
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{
              borderInlineEnd: 'none',
              marginTop: '16px',
              flex: 1,
            }}
            items={adminItems}
          />
          </>
        )}
      </div>
      <div style={{
        position: 'absolute',
        bottom: '20px',
        width: '100%',
        textAlign: 'center',
      }}>
        <Button
          type="default"
          icon={darkTheme ? <BulbOutlined /> : <MoonOutlined />}
          onClick={toggleTheme}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
